import { initialUpperCase } from '@/pages/opinion/utils';
import { dealwithAccountChannelInfo } from '../../render-helper';

export default function accountsChartColumns(params) {
  const isAccount = params.model_type === 'account';
  const isGrowth = ['Publishing Performance', 'Growth of Followers']?.includes(
    params?.name,
  );
  const title = initialUpperCase(params.metrics[0]);

  function dealwithValue(item, key) {
    return item[key] || 0;
  }

  let commonColumns: any = [
    { render: 'date', header: 'Date' },
    {
      render: 'channel',
      header: 'Channel',
      renderHelper: [dealwithAccountChannelInfo('channel', params, isAccount)],
    },
    {
      render: 'value',
      header: params?.name === 'Growth of Followers' ? params?.name : title,
      renderHelper: [dealwithValue],
    },
    { render: 'share', header: 'Share', numFmt: '0.00%' },
  ];

  if (isGrowth) {
    commonColumns.splice(3, 1);
  }
  if (isAccount) {
    commonColumns.splice(2, 0, {
      render: 'channel',
      header: 'Account',
      renderHelper: [dealwithAccountChannelInfo('name', params, isAccount)],
    });
  }

  return [...commonColumns];
}
